import { ENABLED_LANGUAGES, FALLBACK_LANGUAGE } from '@app/i18n'

export type SupportedLocale = typeof ENABLED_LANGUAGES[number]

const KNOWN_LOCALE_SEGMENTS = [ 'ru', 'kk', 'en' ] as const

export function getLocaleFromPath (path: string): SupportedLocale | null {
  const firstSegment = path.split('/').filter(Boolean)[0]

  if (firstSegment && (KNOWN_LOCALE_SEGMENTS as readonly string[]).includes(firstSegment)) {
    return firstSegment as SupportedLocale
  }

  return null
}

export function stripLocaleFromPath (path: string): string {
  const url = new URL(path, 'http://localhost')
  const segments = url.pathname.split('/').filter(Boolean)

  while (
    segments[0] &&
    (KNOWN_LOCALE_SEGMENTS as readonly string[]).includes(segments[0])
  ) {
    segments.shift()
  }

  if (segments.length === url.pathname.split('/').filter(Boolean).length) {
    return path
  }

  const pathname = segments.length ? `/${segments.join('/')}` : '/'
  return `${pathname}${url.search}${url.hash}`
}

export function localizeUrl (path: string, locale: SupportedLocale): string {
  const cleanPath = stripLocaleFromPath(path)
  const url = new URL(cleanPath, 'http://localhost')
  const pathname = url.pathname
  const localizedPath = pathname === '/' ? `/${locale}` : `/${locale}${pathname}`

  return `${localizedPath}${url.search}${url.hash}`
}

export function getDefaultLocale (): SupportedLocale {
  return FALLBACK_LANGUAGE as SupportedLocale
}

export function isValidLocale (locale: string): locale is SupportedLocale {
  return (KNOWN_LOCALE_SEGMENTS as readonly string[]).includes(locale)
}
